import { getUserIdentity } from './authorizationHelper';
import { decryptAES } from './encryptonHelper';
import { USER_PERMISSIONS } from '../../constants/storageKeys';
import { UserOperationTypes } from '../types/AuthorizationProps';

export const isCommissionSelectable = () => {
    const userIdentity = getUserIdentity();
    if (userIdentity !== "ADMIN") {
        const permissions: number[] = JSON.parse(
            decryptAES(localStorage.getItem(USER_PERMISSIONS) || "")
        );
        if (!permissions.includes(UserOperationTypes["Komisyon Seçimi"])) {
            return false;
        }
    }
    return true;
};